import get from 'lodash.get';

const getInitialSetupCompleted = (rootState) =>
  get(rootState, 'ws.site.properties.initialSetupCompleted', false);

export default getInitialSetupCompleted;
